module.exports = "/assets/data/920714ea0ebfe890a0802c8c7c62218b-SW13.data.json";